import React from 'react';
import { FormattedMessage } from 'react-intl';

const Release540 = () => (
    <div style={{ marginLeft: '110px' }}>
        <p className="text-bold text-size-18 margin-bottom-5">
            <FormattedMessage id="help.changelog.5.4.0.featureName" />
        </p>
        <p className="margin-top-0 margin-bottom-5">
            <FormattedMessage id="help.changelog.5.4.0.eTGX" />
        </p>
        <p className="margin-top-0 margin-bottom-5">
            <FormattedMessage id="help.changelog.5.4.0.optimized" />
        </p>
        <p className="text-bold text-size-18 margin-bottom-5">
            <FormattedMessage id="help.changelog.5.4.0.realTimeFleet" />
        </p>
        <p className="margin-top-0 margin-bottom-5">
            <FormattedMessage id="help.changelog.5.4.0.operatingData" />
        </p>
        <p className="margin-top-0 margin-bottom-5">
            <FormattedMessage id="help.changelog.5.4.0.operatingEnergyConsumption" />
        </p>
        <p className="margin-top-0 margin-bottom-5">
            <FormattedMessage id="help.changelog.5.4.0.recuperation" />
        </p>
        <p className="text-bold text-size-18 margin-bottom-5">
            <FormattedMessage id="help.changelog.5.4.0.electricConsumers" />
        </p>
        <p className="margin-top-0 margin-bottom-5">
            <FormattedMessage id="help.changelog.5.4.0.eTGXDetails" />
        </p>
        <p className="text-bold text-size-18 margin-bottom-5">
            <FormattedMessage id="help.changelog.5.4.0.eTruck" />
        </p>
        <p className="margin-top-0 margin-bottom-5">
            <FormattedMessage id="help.changelog.5.4.0.energyEfficiency" />
        </p>

        <p className="text-bold text-size-18 margin-bottom-5">
            <FormattedMessage id="help.changelog.bugFixes" />
        </p>

        <p className="margin-top-0">
            <FormattedMessage
                id="help.changelog.5.4.0.improvements"
                values={{
                    ul: (chunks: React.ReactNode) => <ul className="padding-left-15">{chunks}</ul>,

                    li: (chunks: React.ReactNode) => <li className="margin-bottom-5">{chunks}</li>,
                }}
            />
        </p>
    </div>
);

export default Release540;
